import { useEffect, useState, useCallback } from "react";
import { fetchWithAuth } from "../Utils/fetchWithAuth";

export default function useGet(url) {
  const [fetchedData, setFetchedData] = useState(null);
  const [loading, setLoading]       = useState(true);
  const [error, setError]           = useState(null);
  const [reloadFlag, setReloadFlag] = useState(false); // <-- booleano toggle

  const refetch = useCallback(() => {
    setReloadFlag(f => !f); // toggle true/false
  }, []);

  useEffect(() => {
    if (!url) return;
    const ac = new AbortController();

    const run = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await fetchWithAuth(url, { method: "GET", signal: ac.signal });
        if (!res?.ok) throw new Error(`Errore nella richiesta: ${res?.status}`);
        const json = await res.json();
        if (!ac.signal.aborted) setFetchedData(json);
      } catch (err) {
        if (!ac.signal.aborted) setError(err);
      } finally {
        if (!ac.signal.aborted) setLoading(false);
      }
    };

    run();
    return () => ac.abort();
  }, [url, reloadFlag]); // <-- si rilancia quando cambia reloadFlag

  return { fetchedData, loading, error, refetch };
}
